import React from 'react';
import './Cali.css'; 

const SantaMarta = () => {
  return (
   <div>
    <div className='Espacio-titulo'>
      <h1><a className='Titulo' href="/aip/SKSM.pdf" target="_blank" rel="noreferrer">Aeropuerto Simón Bolivar</a></h1>
    </div>

    <div className='containeraeropuertos'>
      
      <div className='subcontaineraeropuertos'>
        <h1>SID</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 01</th>                      
          </tr>  
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSM/BAQ4C.pdf" target="_blank" rel="noreferrer">BAQ4C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSM/BAQ4C.pdf" target="_blank" rel="noreferrer">EDVA1B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSM/BAQ4C.pdf" target="_blank" rel="noreferrer">MGN3C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSM/BAQ4C.pdf" target="_blank" rel="noreferrer">MGN2D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSM/SUPL2A.pdf" target="_blank" rel="noreferrer">SUPL2A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSM/EVPI2B.pdf" target="_blank" rel="noreferrer">EVPI2B</a></th>
          </tr> 
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSM/EVPI2B.pdf" target="_blank" rel="noreferrer">TIGR2C</a></th>
          </tr> 
           <tr>
            <th className='Procedimientos'><a href="/regionales/SKSM/BAQ1J.pdf" target="_blank" rel="noreferrer">BAQ1J</a></th>
          </tr> 
           <tr>
            <th className='Procedimientos'><a href="/regionales/SKSM/BAQ1J.pdf" target="_blank" rel="noreferrer">STA1F</a></th>
          </tr> 
          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 19</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSM/BAQ4C.pdf" target="_blank" rel="noreferrer">BAQ4C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSM/BAQ4C.pdf" target="_blank" rel="noreferrer">EDVA1B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSM/BAQ4C.pdf" target="_blank" rel="noreferrer">MGN3C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSM/BAQ4C.pdf" target="_blank" rel="noreferrer">MGN2D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSM/SUPL1A.pdf" target="_blank" rel="noreferrer">SUPL1A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSM/SUPL1A.pdf" target="_blank" rel="noreferrer">SUPL1B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSM/SATG1A.pdf" target="_blank" rel="noreferrer">SATG1A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSM/ANLU1B.pdf" target="_blank" rel="noreferrer">ANLU1B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSM/STA1G.pdf" target="_blank" rel="noreferrer">STA1G</a></th>
          </tr> 
          </table>
        </div> 
      </div>

      <div className='subcontaineraeropuertos'>
        <h1>STAR</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 01</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSM/EDVA2A.pdf" target="_blank" rel="noreferrer">EDVA2A</a></th>
          </tr> 
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSM/EDVA2A.pdf" target="_blank" rel="noreferrer">VUMB2C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSM/BAQ2D.pdf" target="_blank" rel="noreferrer">BAQ2D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSM/BA2D.pdf" target="_blank" rel="noreferrer">DARN2C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSM/BAQ2D.pdf" target="_blank" rel="noreferrer">EDVA2D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSM/BAQ2D.pdf" target="_blank" rel="noreferrer">MORG2D</a></th>
          </tr>
           <tr>
            <th className='Procedimientos'><a href="/regionales/SKSM/TIGR1D.pdf" target="_blank" rel="noreferrer">TIGR1D</a></th>
          </tr> 
           <tr>
            <th className='Procedimientos'><a href="/regionales/SKSM/TIGR1D.pdf" target="_blank" rel="noreferrer">UMPU1E</a></th>
          </tr> 
          </table>

          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 19</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSM/EDVA2A.pdf" target="_blank" rel="noreferrer">EDVA2A</a></th>
          </tr> 
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSM/EDVA2A.pdf" target="_blank" rel="noreferrer">VUMB2C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSM/BAQ1G.pdf" target="_blank" rel="noreferrer">BAQ1G</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSM/BAQ1G.pdf" target="_blank" rel="noreferrer">DARN1D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSM/BAQ1G.pdf" target="_blank" rel="noreferrer">DIBA1A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSM/BAQ1G.pdf" target="_blank" rel="noreferrer">EDVAR1J</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSM/BAQ1G.pdf" target="_blank" rel="noreferrer">UMPU1D</a></th>
          </tr>
          </table>
        </div> 
      </div>

      <div className='subcontaineraeropuertos'>
        <h1>IAC</h1>
        <div className='container-tablas'>
           <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 01</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSM/RNPY01.pdf" target="_blank" rel="noreferrer">RNP Y</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSM/RNPZ01.pdf" target="_blank" rel="noreferrer">RNP Z</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSM/VOR01.pdf" target="_blank" rel="noreferrer">VOR</a></th>
          </tr>
          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 19</th>                      
          </tr> 
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKSM/RNP19.pdf" target="_blank" rel="noreferrer">RNP</a></th>
          </tr>
          </table>
        </div>
      </div>

    </div>
  </div>
  );
};
export default SantaMarta;